import { createAction } from 'typesafe-actions'

export const setBackgroundImageTypeState = createAction('CMD / BackgroundImageType / set type')<string>()

export const backgroundImageTypeChanged = createAction('CMD / BackgroundImageType / image background changed')<string>()
